import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

interface ChatDescriptionComponentProps {
    activeChannelName: string;
    activeChannelId: string;
}

export const ChatDescriptionComponent = ({ activeChannelName, activeChannelId }: ChatDescriptionComponentProps) => {
    const { isAmr } = useAssignedAppTypeContext();
    const isOpenChat = activeChannelName === 'Open Chat';
    const isContributorsChat = activeChannelName === 'Contributors';

    const getDisplay = () => {
        let chatText = '';
        if (!activeChannelId) {
            return chatText;
        }
        if (isOpenChat) {
            chatText = 'Communicate with Vivli staff, the Data Contributors, Independent Review Panel and the Research Team.';
        }
        if (isContributorsChat) {
            chatText = isAmr
                ? 'Communicate with all data contributors and Vivli, but not the requester.'
                : 'Communicate with all data contributors and Vivli, but not the requester or IRPs.';
        }

        return chatText;
    };

    return <span>{getDisplay()}</span>;
};
